//import * as contactActions from '../store/actions/contactActions'
import * as messageActions from '../actions/chat/messageActions'
import * as attachmentActions from '../actions/chat/attachmentActions'
import { setOnlineUsers } from "../actions/user.js";
import socket from './socket'

class Listeners {
  constructor(store) {
    this.store = store;
    this.createListeners()
  }

  createListeners() {
    socket.on('onlineUsers', userIds => this.store.dispatch(setOnlineUsers(userIds)))

    socket.on('messagesOnReceive', (messages) => {
      //console.log('received on client', messages)
      this.store.dispatch(messageActions.messagesOnReceive(messages))
    })

    socket.on('messagesOnGetUnreadCount', payload => this.store.dispatch(
      messageActions.messagesReceivedUnreadCount(payload)
    ))

    socket.on('messageOnReceiveNew', payload => this.store.dispatch(
      messageActions.messageOnReceiveNew(payload)
    ))

    socket.on('messagesOnMarkRead', payload => this.store.dispatch(
      messageActions.messagesOnMarkRead(payload)
    ))

    socket.on('messagesOnSeen', payload => this.store.dispatch(
      messageActions.messagesOnSeen(payload)
    ))

    socket.on('messageOnTransmitBytes', (args, fn) => {
      this.store.dispatch(attachmentActions.buffReceived(args))
      fn('1') //reply back on receiving bytes
    })

    socket.on('allFiles', (payload) => {
      this.store.dispatch(attachmentActions.allFilesReceived(payload))
    })
  }

}

export default (store) => new Listeners(store);




// WEBPACK FOOTER //
// ./src/helpers/listeners.js